<template>
  <v-slide-x-transition>
    <component
      :is="drawer.type"
      :width="drawerWidth"
      permanent
      clipped
      app
      v-if="drawer.show"
      mini-variant-width="30"
      style="z-index: 100"
    ></component>
  </v-slide-x-transition>
</template>

<script>
import { mapState } from 'vuex'
import DrawerComponents from './types'

export default {
  name: 'EditorNavigationDrawer',
  components: {
    ...DrawerComponents
  },
  computed: {
    ...mapState('editor', ['drawer']),
    drawerWidth() {
      let width = 0

      switch (this.drawer.size) {
        case 'sm':
          width = 450
          break
        case 'md':
          width = window.innerWidth * 0.6666
          break
        case 'lg':
          width = window.innerWidth
          break
        default:
          width = 450
      }

      return width
    }
  }
}
</script>
